import { render } from "./paperList.vue?vue&type=template&id=3bb9cd60&scoped=true&ts=true"
import script from "./paperList.vue?vue&type=script&lang=ts"
export * from "./paperList.vue?vue&type=script&lang=ts"

import "./paperList.vue?vue&type=style&index=0&id=3bb9cd60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb9cd60"]])

export default __exports__